import { store } from 'App';
import {
  pusherConnectedAction,
  pusherDisconnectedAction,
  pusherErrorAction,
  pusherProductSyncAction,
} from 'utils/pusher/pusherActions';
import { EPusherEvents, EPusherSystemEvents, IPusherReducer } from 'utils/pusher/pusherTypes';

const actionByEvent = {
  [EPusherSystemEvents.Connected]: pusherConnectedAction,
  [EPusherSystemEvents.Error]: pusherErrorAction,
  [EPusherSystemEvents.Disconnected]: pusherDisconnectedAction,
  [EPusherEvents.ShopifyProductsSyncComplete]: pusherProductSyncAction,
};

export const pusherReducer = async({ event, data }: IPusherReducer) => {
  const { dispatch } = store;

  // @ts-ignore
  return dispatch(actionByEvent[event](data));
};
